<template>
  <div style="overflow-anchor: none">
    <!--  Meeting Header -->
    <div v-bind:class="meetingHeaderClass">
      <!-- <div  style=""> -->
        <b-container fluid style="Xbackground-color:pink">
          <b-row no-gutters style="Xbackground-color:beige">
            <b-col cols="9" data-hj-suppress>
              <div style="width: 90%; height: 100%; display: flex">

                <!-- Container for Meeting Title, Objective, Agenda Label -->
                <div style="display:flex; flex-direction:column">

                  <!-- Meeting Title -->
                  <!-- <div style="Xmargin-top:auto;" > -->
                    <!-- <div v-if="meeting.status === 'started'" class="sectionLabel" style="Xmargin-bottom:0.2rem;">Meeting</div> -->
                    <div class="meetingTitle" ref="meetingTitle" @click="editMeeting" v-b-tooltip.hover.bottom="'Click to Edit'">{{meeting.name}}</div>
                      <div class="meetingPurpose" v-if="meeting.purpose">{{meeting.purpose}}</div>
                  <!-- </div> -->

                  <!-- Agenda Label - Displays when meeting running - HIDDEN  -->
                  <!-- <div  v-if="meeting.status == 'started'" class="sectionLabel" style="margin-top: 0.5rem">
                    Agenda
                      <span style="Xfloat:right">
                        <font-awesome-icon  id="addAgendaItemIcon" :icon="['fas', 'plus']" size="sm" @click="showNewItemForm" />
                        <b-tooltip target="addAgendaItemIcon" title="Add Agenda Item" variant="secondary"></b-tooltip>
                      </span>
                  </div> -->

                  </div>


                <!--  Agenda Label & Meeting Controls -->
                <div style="padding-top:0.5rem; margin-left:auto; display:flex;flex-direction:column;justify-content: center; Xbackground-color:lavender">
                  <!--  Meeting Controls  -->
                  <span  style="Xtext-align: right; Xfloat:right; ">
                    <!-- <b-btn v-if="!meeting.status && !meeting.showCalendarUpdate" variant="primary" @click="startMeeting()" size="sm">Start Meeting</b-btn> -->

                    <!--  Start meeting display if meeting shared and not started  -->
                    <!-- <template v-if="!meeting.status  & agenda.length > 0 && $moment(meeting.date).isSameOrBefore($moment().add(1,'days'))"> -->
                    <template v-if="!meeting.status  & agenda.length > 0 && $moment(meeting.date).isSameOrBefore($moment().startOf('day'))">
                    <b-btn id="startMeeting" variant="primary" @click="startMeeting()" size="sm">Start the Meeting</b-btn>
                    <b-tooltip target="startMeeting" title="Start the meeting now" variant="secondary"></b-tooltip>
                    </template>&nbsp;

                    <!-- Send Meeting display if agenda created and meeting not shared already -->
                    <!-- <template  v-if=" agenda.length > 0 && ! meeting.googleCalendarId  && ! meeting.status" style="margin-left:10rem">
                      <b-overlay
                           :show="busy"
                           rounded
                           opacity="0.6"
                           spinner-small
                           spinner-variant="primary"
                           class="d-inline-block"
                           @hidden="sendingInvites"
                         >
                      <b-btn size="sm" id="sendMeeting" variant="primary" @click="sendInvitesGoogle">Invite Attendees</b-btn>
                      </b-overlay>
                      <b-tooltip target="sendMeeting" title="Send Meeting invitation to attendees" variant="secondary"></b-tooltip>
                    </template> -->


                    <!-- <b-btn size="sm" v-if="meeting.showCalendarUpdate=='update'" variant="primary" @click="createCalendarICS">Update Calendar</b-btn> -->
                    &nbsp;<b-btn size="sm" v-if="meeting.status == 'ended'" @click="startMeeting()" variant="primary">Re-Start Meeting</b-btn>

                    <!-- <b-button size="sm" v-if="meeting.status == 'started' && currentItem > 0" variant="secondary" @click="previousItem">< Previous</b-button>&nbsp; -->
                    <b-button size="sm" v-if="meeting.status == 'started' && currentItem < (agenda.length-1)" variant="primary" @click="nextItem" >Next Item ></b-button>
                    <b-btn  size="sm" v-if="meeting.status == 'started' && currentItem == (agenda.length-1)" variant="primary" @click="endMeeting()">End Meeting ></b-btn>

                    <!-- Close Meeting Icon HIDDEN -->
                    <!-- <div style="display:inline-flex; padding-bottom:15px; vertical-align: middle; margin-left: 0.5rem">
                      <font-awesome-icon id="closeMeetingIcon" :icon="['far', 'window-close']" size="2x" @click="$router.push({name: 'MyMeetings'})"" />
                    </div> -->


                    <b-dropdown id="meetingOptions" size="sm" variant="link" right no-caret style="Xmargin-left: 0.3rem; color: #afadad">
                      <template v-slot:button-content>
                        <font-awesome-icon  style="color:#afadad" :icon="['fas', 'ellipsis-v']" size="lg" /><span class="sr-only">Search</span>
                      </template>
                      <!-- <b-dropdown-item v-if="!meeting.status && !meeting.googleCalendarId" @click="startMeeting">Start the Meeting</b-dropdown-item> -->
                      <b-dropdown-item @click="editMeeting()">Edit Meeting</b-dropdown-item>
                      <b-dropdown-item @click="showFollowUpModal" v-if="meeting.status=='ended'">Follow up Meeting</b-dropdown-item>
                      <b-dropdown-item v-if="meeting.showCalendarUpdate == 'create' && agenda.length > 0"  @click="createCalendarICS">Download Calendar Invite</b-dropdown-item>
                      <b-dropdown-item v-if="meeting.showCalendarUpdate == 'update' && agenda.length > 0"  @click="createCalendarICS">Download Calendar Update</b-dropdown-item>
                      <b-dropdown-item v-if="meeting.status === 'started'" @click="previousItem()">Previous Agenda Item</b-dropdown-item>
                      <b-dropdown-item v-if="meeting.status === 'started'" @click="endMeeting()">End Meeting</b-dropdown-item>
                      <!-- <b-dropdown-item vif="meeting.googleCalendarId" @click="updateGoogleCalendar">Update Calendar Invites</b-dropdown-item> -->
                      <b-dropdown-item v-if="agenda.length > 0" @click="exportAgenda">Export Meeting (PDF)</b-dropdown-item>
                      <b-dropdown-item @click="confirmDelete(meeting)">Delete Meeting</b-dropdown-item>
                      <b-dropdown-item @click="$router.push({name: 'MyMeetings'})">Exit Meeting</b-dropdown-item>
                    </b-dropdown>
                    <b-tooltip target="meetingOptions" title="Options" variant="secondary"></b-tooltip>

                  </span>
              </div>

              </div>
            </b-col>

            <b-col cols="3" style="display: flex; align-items: center; justify-content: center; Xbackground-color:pink">
              <Timer v-show="meeting.status=='started'" id="countDown" :startTime="meeting.startTime" :status="meeting.status" :duration="meeting.duration" :meetingTitle="meeting.name" class="timer"></Timer>
              <b-tooltip target="countDown" style="text-align: left" variant="secondary" placement="left">
                Started: {{meeting.startTime | moment('HH:mm')}}<br />
                Duration: {{meeting.duration}} minutes
              </b-tooltip>
              <div class="meetingTime" v-if="!meeting.status">{{[meeting.date + ' ' + meeting.time] | moment("calendar")}}</div>
              <div class="meetingTime" v-if="meeting.status=='ended'">Ended {{meeting.endTime | moment("calendar")}}</div>

              <font-awesome-icon style="color: #c3cdc3; position:fixed; top:6px; right: 6px; height:1.5rem; width: 2rem; Xmargin-left: auto" id="closeMeetingIcon" :icon="['far', 'window-close']" size="2x" @click="$router.push({name: 'MyMeetings'})" />
              <b-tooltip target="closeMeetingIcon" title="Exit meeting" variant="secondary"></b-tooltip>


              <!--  Meeting Time  -->
              <!-- <div style="margin-left: 0.5rem; margin-right: 0.1rem;">
                <div v-show="meeting.status=='started'" style="line-height: 1.9rem;">
                  <Timer id="countDown":startTime="meeting.startTime" :status="meeting.status" :duration="meeting.duration" class="timer"></Timer>
                </div>
                <h2 class="meetingTime" v-if="!meeting.status">{{[meeting.date + ' ' + meeting.time] | moment("calendar")}}</h2>
                <h2 class="meetingTime" v-if="meeting.status=='ended'">Ended {{meeting.endTime | moment("calendar")}}</h2>

              </div> -->

            </b-col>
          </b-row>
        </b-container>
      <!-- </div> -->
    </div>

    <div  style="margin:2rem 2.5rem">
    <b-container fluid>
    <b-row no-gutters>

      <!--  Meeting Content Left Column  -->
      <b-col cols="9">
        <div style="width:90%; margin-bottom:0.8rem">

          <!-- Work around to ensure focus is at top of screen -->
          <b-input style="display:none" autofocus>test</b-input>

          <!-- Vertical space to allow scrolling of agenda -->
          <div v-if="meeting.status == 'started'" style="margin:2.5rem 0">&nbsp;</div>

          <!--  Agenda Label (meeting ended)-->
          <!-- <div v-if="meeting.status == 'ended'">
            <span class="sectionLabel">Meeting Notes</span> &nbsp;
            <span style="Xfloat:right" id="addAgendaItemIcon" v-show="!showNewAgendaForm">
               <font-awesome-icon  :icon="['fas', 'plus']" size="sm" @click="showNewItemForm" />
               <b-tooltip target="addAgendaItemIcon" title="Add Agenda Item" variant="secondary"></b-tooltip>
            </span>
          </div> -->

          <!--  Agenda Label (meeting not started)-->
          <div Xv-if="!meeting.status || meeting.status == ''" style="margin-bottom: 0rem">
            <!-- <h2 style="display:inline; color: #808080;">Agenda</h2> -->
            <span class="sectionLabel">Agenda</span>&nbsp;
            <span style="position:relative;left;40px; float:right" id="addAgendaItemIcon" v-show="!showNewAgendaForm">
               <font-awesome-icon  :icon="['fas', 'plus']" size="lg" @click="showNewItemForm" :id="'addItem'"/>
               <b-tooltip target="addAgendaItemIcon" title="Add Agenda Item" variant="secondary"></b-tooltip>
            </span>
          </div>
        </div>

        <!--  Empty State Agenda  -->
        <!-- <b-card no-body class="itemCutOut" v-if="agenda.length == 0 && showNewAgendaForm == false">
          <div style="color: var(--primaryColor1); cursor: pointer;font-size:1.2rem" >
            <span @click="showNewItemForm">
            <img src="@/assets/CurvedArrow.png" style="margin-bottom: 2rem; margin-left: 4.3rem"/>
            Create your meeting agenda or
              </span>
              &nbsp;<b-button size="sm" variant="primary" @click.prevent="showTemplateModal=true" style="margin-bottom: 0.3rem">Select a Template</b-button>
              </div>
        </b-card> -->

        <!-- <b-card no-body class="itemCutOut" v-if="agenda.length == 0 && showNewAgendaForm == false">
          <div style="cursor: pointer;font-size:1.2rem; Xmargin-left:3rem; display:flex; flex-direction:column;">
            <div style="align-self:center; Xbackground-color:pink; margin-left:9rem; margin-top:-2rem" >
              Start creating your meeting agenda
              <img src="@/assets/EmptyStateLongCurve.png" style="margin-bottom: 2.2rem; margin-left: 1.3rem; Xtransform: scaleX(-1) rotate(-35deg)"/>
              <div style="margin-top:-2rem">
                or
                <a class="contentLink" href="#" @click="showTemplateModal=true" Xstyle="color:var(--primaryColor1);hover:text-">choose a standard meeting template</a>
              </div>
            </div> -->

        <!-- <b-card no-body class="itemCutOut" v-if="agenda.length == 0 && showNewAgendaForm == false">
        <div style="text-align:center">
          Select a <a class="contentLink" href="#" @click="showTemplateModal=true"> Meeting Agenda Template</a>
          <div style="margin-top:0.5rem">
            or Create your Own Agenda
            <img src="@/assets/EmptyStateLongCurve.png" style="margin-bottom: 2.2rem;"/>
          </div>
        </div>
        </b-card> -->

        <b-card noBody class="itemCutOut" v-if="agenda.length == 0 && showNewAgendaForm == false">
          <div style="display:flex;justify-content:space-evenly">
            <div style="Xbackground-color:pink;flex-basis:30%">
            </div>
            <div style="Xbackground-color:#C7CEEA;flex-basis: 20rem; text-align:center">
              Select a <a href="#" @click="showTemplateModal=true" class="contentLink">Meeting Agenda template</a>
              <div style="margin-top: 0.8rem">
                or Create your Own Agenda
              </div>
            </div>
            <div style="Xbackground-color:#B5EAD7;flex-basis:30%; display:flex">
              <img src="@/assets/EmptyStateLongCurve.png" style="align-self:flex-end; margin-left: -3rem"/>
            </div>
          </div>
        </b-card>


        <b-list-group ref="agenda">

          <transition-group name="flip-list" tag="div">

            <!-- Agenda List Item -->
            <b-list-group-item v-for="(item) in sortedAgenda" v-bind:class="itemClass(item)"  v-bind:ref="'item' + item.id" v-bind:key="item.id" @mouseover="setCurrentItem(item)" @xmouseover="currentItemMouseover=item.id" @mouseout="currentItemMouseover=''" data-hj-suppress>

              <!-- agenda Item controls -->
                <!-- Was Here -->

              <b-container fluid  class="px-0">
                <b-row no-gutters>

                  <!-- Column with item index number -->
                  <b-col cols="1" class="itemLeftCol">
                    <span v-bind:class="item.position == currentItem ? 'currentitemNo No' + item.position : 'itemNo No' + item.position">{{item.position+1}}</span>
                    <!-- <div v-if="editAgendaIndex === item.id" style="margin-left:0.5rem">
                      <div class="bumpItem" @click="bumpItem(item,-1)">
                        <font-awesome-icon :icon="['fas', 'caret-up']" />
                      </div>
                      <div class="bumpItem" @click="bumpItem(item,1)">
                        <font-awesome-icon :icon="['fas', 'caret-down']" />
                      </div>
                    </div> -->
                    </b-col>
                  <b-col cols="11">

                    <!-- Agenda Item -->
                    <template v-if="editAgendaIndex != item.id">
                    <b-row no-gutters class="itemRow top">
                      <b-col cols="9" style="display:flex; flex-direction: column; justify-content: center">
                        <div v-bind:class="(item.position == currentItem ? 'currentItemTitle': 'itemTitle') + ' i' + item.position">{{item.topic}}</div>
                        <div class="itemObjective"><span v-if="item.objective != ''">{{item.objective}}</span></div>
                      </b-col>
                      <b-col cols="3" class="itemRightCol">
                        <div v-bind:class="'itemTime i' + item.position">
                          <transition name="fade">
                            <span class="editItemIcon" v-show="item.id == currentItemMouseover">
                              <!-- <font-awesome-icon id="editIcon" :icon="['fa', 'pencil-alt']" size="1x" @click="editItem(item)"/> -->

                                <!-- <font-awesome-icon  style="color:var(--primaryColor1)" :icon="['fas', 'ellipsis-v']" size="lg" /><span class="sr-only">Search</span> -->
                              <!-- <b-tooltip target="editIcon" title="Edit Agenda Item"></b-tooltip> -->
                            </span>
                        </transition>
                          <span>
                            <font-awesome-icon :icon="['far', 'clock']" data-html2canvas-ignore/>
                            {{item.duration}}m
                          </span>


                          <!-- agenda Item controls -->
                          <span class="itemControls" style="Xfloat:right;Xposition:relative"  xv-show="item.id == currentItemMouseover" data-html2canvas-ignore>
                            <b-dropdown  size="sm" variant="link" right no-caret style="margin-left: 0.1rem; margin-right: -1.4rem">
                              <template v-slot:button-content>
                                <font-awesome-icon style="color:#6c757d" id="editIcon" :icon="['fas', 'ellipsis-v']" size="1x" />
                              </template>
                              <b-dropdown-item @click="editItem(item)">Edit Item</b-dropdown-item>
                              <b-dropdown-item @click="bumpItem(item, -1)">Move Up</b-dropdown-item>
                              <b-dropdown-item @click="bumpItem(item, 1)">Move Down</b-dropdown-item>
                              <b-dropdown-item @click="removeItem(item, 1)">Remove Item</b-dropdown-item>
                            </b-dropdown>
                          </span>
                        </div>

                          <div v-if="item.owner != '' " class="itemOwner">
                            {{item.owner}}
                          </div>
                      </b-col>
                    </b-row>
                  </template>

                  <!--  Edit Agenda Item  -->
                  <EditAgendaItem v-if="editAgendaIndex == item.id" mode="update" :agendaItem="item"  @cancelEditAgendaItem="editAgendaIndex = -1" @saveAgendaItem="saveAgendaItem(item)" v-on:moveItem="bumpItem"xw></EditAgendaItem>

                  </b-col>
                </b-row>

                <!-- Agenda Item Description and Links  -->
                <b-row no-gutters v-if="item.description  && editAgendaIndex != item.id">
                  <!-- <b-col cols="1" class="itemLeftCol"></b-col> -->
                  <b-col cols="11">
                    <div v-if="item.description && (meeting.status !== 'started' || item.position == currentItem  )" class="itemNotes" Xstyle="margin-left:0.4rem">
                      <!-- {{item.description}} -->
                      <div>
                        <ul>
                          <li v-bind:class="'descriptionBullet i' + item.position"" v-for="line in item.description.split('\n')"><span class="itemNote">{{line}}</span></li>
                        </ul>
                      </div>
                    </ul>
                    </div>
                  </b-col>
                </b-row>
                <b-row no-gutters style="padding-top:0.5rem" v-if="item.links  && editAgendaIndex != item.id"">
                  <b-col cols="1" class="itemLeftCol"></b-col>
                  <b-col cols="11" style="display:flex">
                    <!-- <div v-for="(link) in item.content.filter(entry => {return entry.type === 'link'})" class="itemLink"> -->
                    <div v-for="(link) in item.links" class="itemLink">
                        <a target="_blank" :href="link.url">
                          <font-awesome-icon :icon="['fas', 'link']" size="1x" style="color:#afadad;Xline-height: 40px;cursor:pointer" />
                          {{link.title}}
                        </a>&nbsp;
                    </div>
                  </b-col>
                </b-row>
              </b-container>

              <!--  Log Items  -->
              <!--
              Show list of log items if there are some to display or it's the current item
              -->
              <div class="logItemsContainer" v-if="getLogItems(item.id).length > 0 || item.position == currentItem">
                <div class="meetingOutcomesLabel" v-if="item.position == currentItem" v-bind:class="' i' + item.position">
                  Meeting Outcomes
                </div>
                <ListLogItems :logItems="getLogItems(item.id)" :meetingStatus="meeting.status" v-on:removeLogItem="deleteLogItem" v-on:markActionComplete="updateActionComplete"></ListLogItems>

                <div v-if="(item.position <= currentItem || meeting.status == 'ended') && item.id != editAgendaIndex && getLogItems(item.id)">
                  <div class="itemBody">
                    <PostLogItem v-if="item.position == currentItem" :agendaItem="item" :attendees="attendees" mode="update" @postLogItem="insertLog"></PostLogItem>
                  </div>
                </div>
              </div>


            </b-list-group-item>

          <!-- New Agenda item Form -->
          <b-list-group-item v-if="showNewAgendaForm == true" v-bind:key="0">
            <b-row>
              <b-col cols="1"  class="itemLeftCol">
                  <span class="itemNo" style="margin-top: 0.5rem; margin-left: 1rem " v-bind:class="'No' + (parseInt(sortedAgenda.length)+1)">{{sortedAgenda.length+1}}</span>
              </b-col>
              <b-col cols="11">
                   <EditAgendaItem mode="create" :agendaItem="blankAgendaItem" :nextItemNo="sortedAgenda.length+1" @cancelEditAgendaItem="showNewAgendaForm=false" @saveAgendaItem="saveItem"></EditAgendaItem>
              </b-col>
            </b-row>
          </b-list-group-item>

         </transition-group>
        </b-list-group>
        <div style="margin-bottom:100vw; background-color:pink"></div>


      </b-col>
      <!--Meeting Content Right Column -->
      <b-col cols="3">
        <!-- Attendees -->
        <div v-bind:class="attendeeClass">
          <div v-if="meeting.status !== 'started'" style="margin-bottom:0.8rem">

          <!-- <h2 style="display:inline; color: #808080;">Attendees</h2> -->
          <span class="sectionLabel">Attendees</span>&nbsp;
  <!--         <span style=float:right><b-button variant="outline-primary" size="sm" @click="showAttendeeForm=true" v-if="!showAttendeeForm">Add Attendee</b-button></span>-->
          <span style="float:right" id="addAttendeeIcon" v-if="!showAttendeeForm">
             <font-awesome-icon  :icon="['fas', 'plus']" size="lg" @click="showAttendeeForm=true" />
          </span>
          <b-tooltip target="addAttendeeIcon" title="Add Attendee" variant="secondary"></b-tooltip>
          </div>
          <transition-group name="flip-list" tag="div">
            <div v-for="attendee in attendees" v-bind:key="attendee.id" style="clear:both">
              <b-container class="attendee" @mouseover="mouseOverAttendee=attendee.id" @mouseout="mouseOverAttendee=''">
                <b-row no-gutters style="max-height:2.8rem">
                  <b-col cols="2" align-self="center">
                    <span>
                      <!-- + attendee.status=='Not here yet' ? ' notHere' : ' XZX' -->
                      <b-dropdown no-caret variant="link">
                        <template slot="button-content" >
                          <span xstyle="font-size:1rem" id="dropButton" v-bind:class="'moodButton' + (attendee.status=='Not here yet' ?  ' notHere' : '' )"><font-awesome-icon :icon="attendeeStatusIcon[attendee.status]" size="2x" /></span>
                        </template>
                        <b-dropdown-item v-for="(mood,key) in attendeeStatusIcon" :key="key" @click="setAttendeeStatus(attendee,key)">
                          <font-awesome-icon :icon="mood" size="1x" class="moodIcon"/>&nbsp; {{key}}
                        </b-dropdown-item>
                      </b-dropdown>
                    </span>
                </b-col>
                <b-col cols="8"  align-self="center" class="attendeeName" v-b-tooltip.hover :title="attendee.email" data-hj-suppress>
                  &nbsp;{{attendee.name}}
                </b-col>
                <b-col align-self="center" cols="1">
                  <font-awesome-icon v-show="mouseOverAttendee == attendee.id" :icon="['fas', 'minus-circle']" size="1x" @click="removeAttendee(attendee)" style="color:#afadad;line-height: 40px;cursor:pointer" />
                </b-col>
                    </b-row>
                  </b-container>
              </div>
            </transition-group>
            <span style="float:right; margin-right: 0.4rem" id="addAttendeeIcon" v-if="!showAttendeeForm  && meeting.status=='started'">
               <font-awesome-icon  :icon="['fas', 'plus']" size="lg" @click="showAttendeeForm=true" />
            </span>
            <b-tooltip target="addAttendeeIcon" title="Add Attendee" variant="secondary"></b-tooltip>

            <div style="Xborder-top: 1px solid #00000020"></div>
  <!--            New Attendee Form  -->
              <transition name="fade">
              <b-container class="attendeeForm" v-if="showAttendeeForm">
              <b-row no-gutters style="xborder-top:1px solid #00000020; padding-top:5px">
                <b-col cols="3" align="center">
                <span class="moodButton">
                  <font-awesome-icon :icon="['far', 'square']" size="2x" style="color:lightgray"/>
                </span>
                </b-col>
              <b-col cols="9">
                   <b-form-input xsize="sm" id="attendeeNme" placeholder="Attendee's name" v-model="attendee.name" v-on:focus.native="attendeeFormFocus=true" v-on:blur.native="attendeeFormFocus = false" @keyup.enter.native="addAttendee()"></b-form-input>
                <b-form-group style="margin-top:2px">
                  <b-form-input  size="sm" id="attendeeEmail" type="email" placeholder="Email address" v-model="attendee.email" @keyup.enter.native="addAttendee()" :state="emailValid"></b-form-input>
                  <b-form-invalid-feedback id="">Enter a valid email address</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              </b-row>
                <b-row align-h="end" no-gutters style="border-bottom:1px solid #00000020; padding-bottom:5px">
                <b-col cols="12">
                  <span style="float:right">
                  <b-btn size="sm" variant="secondary" @click="showAttendeeForm=false">Cancel</b-btn>&nbsp;
                  <b-btn size="sm" variant="primary" @click="addAttendee()">Add Attendee</b-btn>
                  </span>
                </b-col>
                </b-row>
              </b-container>
          </transition>
          <br>
          <b-card v-if="meeting.meetingLink" style="cursor:pointer; margin-top:2rem; width:18.5rem" @click="openConferencingLink">
            <img v-if="meeting.meetingLink.includes('google')" src="@/assets/meet_logo_dark.png" style="height:2.3rem; width:2.3rem; "/>
            <img v-else-if="meeting.meetingLink.includes('zoom')" src="@/assets/zoomMeeting.png" style="height:2.5rem; width:3rem; "/>
            <a :href="meeting.meetingLink" style="color: #808080; margin-left:0.4rem;" target="_new" >{{conferenceLinkText}}</a>
          </b-card>
        </div>
          <!--  Meeting Link -->
<!--
          <xb-card class="meetingLink">
            <h2>Meeting link</h2>
            <b-input-group>
              <b-form-input style="max-width:13rem" :value="shareURL" size="sm"></b-form-input>
              <b-input-group-append>
                <b-btn variant="secondary" size="sm">copy</b-btn>
              </b-input-group-append>
            </b-input-group>
          </xb-card>
-->
      </b-col>
    </b-row>
    </b-container>
    </div>

    <b-container fluid class="meetingContent">
    <b-row class="row topM">
      <!-- Agenda Column -->
      <b-col cols="8">
     <!-- End of Agenda Column -->
      </b-col>
      <!--  Attendee column -->
      <b-col cols="4">

      </b-col> <!--  End of Attendee column -->
    </b-row>
    </b-container>

  <!-- Meeting Minutes Modal -->
   <b-modal id="modalMinutes" ref="modal" size="lg" title="Send Meeting Notes"  ok-only scrollable v-model="showMinutesModal">
     <div v-if="emailStatus === 'NOT_SENT'" >
     <h2>Meeting Summary</h2>
     <p>Date: {{meeting.date | moment('DD-MMM-YYYY')}} {{meeting.time}}
     </p>
     <p>Attendees:<br>
     <span v-for="attendee in attendees" v-bind:key="attendee.id">{{attendee.name}},&nbsp;</span>
     </p>
     <p>What was agreed:<br>
     <ul>
     <li v-for="decision in decisions" v-bind:key="decision.id">{{decision.text}}</li>
     </ul>
     <p>Notes:<br>
     <ul>
     <li v-for="note in notes" v-bind:key="note.id">{{note.text}}</li>
     </ul>
     </p>
    <p>Actions:<br>
      <table>
      <tr><th class="actions">Action</th><th class="actions">Owner</th><th class="actions">Due Date</th></tr>
        <tr v-for="action in actions" v-bind:key="action.id">
          <td class="actions">{{action.text}}</td>
          <td class="actions">{{action.owner.name}}</td>
          <td class="actions">{{action.date | moment('ddd DD-MMM-YYYY')}}</td>
        </tr>
      </table>
     </p>
    </div>
    <div v-if="emailStatus==='SENDING'" style="height:50vh">Sending Email.</div>
    <div v-if="emailStatus==='SENT'" style="height:50vh">Email has been sent.</div>
    <div v-if="emailStatus==='ERROR'" style="height:50vh">Sorry it was not possible to email the meeting minutes at this time.</div>
      <div slot="modal-footer" v-if="emailStatus === 'NOT_SENT'">
        <span style="float:right">
          <b-input-group>
            <b-form-radio-group v-model="meetingSendTo" :options="[{text:'Send to all Attendees',value:'all'}, {text:'Send to Me', value:'me'}]" name="radio-inline">
          </b-form-radio-group>
          <b-button size="sm" variant="secondary" @click="showMinutesModal=false">Don't Send</b-button>&nbsp;
          <b-button size="sm" variant="primary" @click="sendMinutes">Send</b-button>
          </b-input-group>
        </span>
      </div>
    </b-modal>


    <!--  Delete Modal -->
     <b-modal id="modalDelete" ref="modal" title="Warning" style="z-index:9999">
     <p>Are you sure you want to delete this meeting?</p>

    <div slot="modal-footer" class="w-100">
      <span style="float:right">
        <b-button size="sm" variant="secondary" @click="cancelDelete">Cancel</b-button>&nbsp;
        <b-button id="confirmDelete" size="sm"  variant="primary" @click="deleteMeeting(meeting)">Delete</b-button>
      </span>
    </div>
  </b-modal>

  <!-- Follow Up Modal -->
  <b-modal size="lg" id="modalFollowUp" ref="modalFollowUp" title="Create a Follow Up Meeting" style="z-index:9999" @ok="createFollowUp">
    <p>
      <MeetingTime :meeting="followUpMeeting" @dateChanged="followUpMeeting.date=$moment($event).format('YYYY/MM/DD')" @timeChanged="followUpMeeting.time=$event" @durationChanged="followUpMeeting.duration=$event"></MeetingTime>
    </p>
  </b-modal>

  <!-- Select Template Modal -->
  <b-modal size="lg" id="modalSelectTemplate" ref="modalSelectTemplate" title="Meeting Agendas" v-model="showTemplateModal">
    <div v-for="category in new Set(this.templates.map(a => a.category))">
      <b>{{category}}</b><br />
      <div v-for="template in templates.filter(a => a.category == category)">
        <b-btn variant="link" @click="selectTemplate(template.title)" style="color:var(--primaryColor1)">
          {{template.title}}
        </b-btn>
      </div>
    </div>
  </b-modal>

  </div>
</template>
<script>
import {firebase, db, router, VueBootstrapTypeahead} from '../main'
import Timer from './Timer.vue'
import EditAgendaItem from './EditAgendaItem.vue'
import PostLogItem from './PostLogItem.vue'
import ListLogItems from './ListLogItems.vue'
import MeetingTime from './MeetingTime.vue'
import * as jsPDF from 'jspdf'
import templates from '../templates.js'

export default {
  name: 'ViewMeeting',
  props: ['user'],
  data () {
    return {
      templates: templates,
      showTemplateModal: false,
      followUpDate:'',
      sendingInvites: false,
      meetingScroll: 'header',
      id: '',
      meeting: {},
      followUpMeeting: {name:'followUP', date:this.$moment().add(1,'d').format('YYYY/MM/DD'), time:'10:00', duration:'60'},
      currentItem: -1,
      currentItemMouseover: '',
      startTime: '',
      endTime: '',
      agenda: [],
      blankAgendaItem: {topic: '', objective: '', owner: this.user.displayName, duration: '15', position: 0, links: []},
      agendaItemID: '',
      showNewAgendaForm: false,
      editAgendaIndex: -1,
      logOptions: [{text: 'Action', value: 'action'}, {text: 'Note', value: 'note'}],
      logOptionsSelected: 'note',
      attendee: {name: '', email: '', status: 'Not here yet'},
      attendees: [],
      attendeeFormFocus: false,
      attendeeStatusIcon: {'Not here yet': ['far', 'square'], 'Here': ['far', 'check-square'], 'Happy': ['far', 'smile'], 'Sad': ['far', 'frown-open'], 'Anxious': ['far', 'grimace'], 'Angry': ['far', 'angry'], 'Meh': ['far', 'meh-rolling-eyes']},
      showAttendeeForm: false,
      mouseOverAttendee: '',
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      log: [],
      logItem: {logType: 'note', text: '', owner: '', date: this.$moment().add(3, 'd').format('YYYY-MM-DD')},
      showMinutesModal: false,
      emailStatus: 'NOT_SENT', // NOT_SENT, SENDING, SENT,ERROR
      meetingSendTo: 'all'
    }
  },
  computed: {
    conferenceLinkText () {
      if (this.meeting.meetingLink.includes('google')) {
        return "Join Google Meet"
      }
      else if (this.meeting.meetingLink.includes('zoom')){
        return 'Join Zoom Meeting'
      }
      else {
        return 'Join Video Conference'
      }
    },
    attendeeClass () {
      if (this.meeting.status == 'started') {
        return 'attendeesFixed'
      } else {
        return 'attendees'
      }
    },
    meetingHeaderClass () {
      if (this.meeting.status =='started') {
        return 'collapseHeader'
      } else  {
        return 'header'
      }
    },
    shareURL () {
      return window.location.hostname + ':' + window.location.port + '/#/joinMeeting/' + this.id
    },
    sortedAgenda () {
      return this.agenda.slice().sort((a, b) => parseInt(a.position) - parseInt(b.position))
    },
    decisions () {
      return this.log.filter(x => x.logType === 'decision')
    },
    notes () {
      return this.log.filter(x => x.logType === 'note')
    },
    actions () {
      return this.log.filter(x => x.logType === 'action').map(action => {
        var newAction = Object.assign({}, action)
        newAction.id = action.id
        return newAction
      })
    },
    openActions () {
      return this.log.filter(x => x.logType === 'action' && x.actionStatus !== 'complete')
    },
    emailValid () {
      return this.attendee.email === '' || this.reg.test(this.attendee.email)
    }
  },
  watch: {
    log () {
      /** Update to log is now handled by cloud function: updateMeeting*/
      //db.collection('Meetings').doc(this.id).update({decisions: this.decisions,actions:this.actions})
    }
  },
  methods: {
    selectTemplate (title) {
      var template = this.templates.filter(a => a.title == title)[0]
      var meetingDuration = 0
      template.agenda.forEach(item => {
        db.collection('Meetings').doc(this.meeting.id).collection('agenda').add({topic:item.topic,objective:item.objective,description: item.description ? item.description : '', duration:item.duration,position:item.position, owner:item.owner ? item.owner : this.user.displayName})
        meetingDuration += parseInt(item.duration)
      })
      db.collection('Meetings').doc(this.meeting.id).update({name:title,duration: meetingDuration.toString()})
      this.showTemplateModal = false
    },
    createFollowUp () {
      alert('select Template now')
    },
    showFollowUpModal () {
      this.$refs.modalFollowUp.show()
    },
    createFollowUp () {
      mixpanel.track('Create Follow-up Meeting')

      // Create new meeting & set the date time
      this.followUpMeeting.owner = this.meeting.owner
      this.followUpMeeting.name = this.meeting.name
      var updates = []
      db.collection('Meetings').add(this.followUpMeeting).then((docRef) => {
        // Add the attendees to the new meeting
        this.attendees.forEach(attendee=>{
          updates.push(db.collection('Meetings').doc(docRef.id).collection('attendees').add(attendee))
        })
        // For each agenda item - add to logCollection
        this.agenda.forEach((agendaItem) => {
          db.collection('Meetings').doc(docRef.id).collection('agenda').add(agendaItem).then(agendaDocRef => (
            this.log.filter(filterLog => filterLog.logType=='action' && filterLog.agendaItemId == agendaItem.id).forEach(logItem => {
              // Copy over any open actions and remove them from the previous meeting
              debugger
              if(!logItem.actionStatus) {
                logItem.agendaItemId = agendaDocRef.id
                // var updates = []
                updates.push(db.collection('Meetings').doc(docRef.id).collection('log').add(logItem))
                updates.push(db.collection('Meetings').doc(this.meeting.id).collection('log').doc(logItem.id).delete())
                Promise.all(updates).then(values => {
                  debugger
                  router.replace({query: {id:docRef.id}}).catch(err => {})
                })
            }
            })
          ))
        })
        // debugger
        // Promise.all(updates).then(values => {
        //   router.replace({query: {id:docRef.id}}).catch(err => {})
        // })
      })
      // Display new meeting
    },
    openConferencingLink () {
      debugger
      window.open(this.meeting.meetingLink,'_new')
    },
    exportAgenda () {
        mixpanel.track('Export Meeting')
        var doc = new jsPDF('p', 'pt', 'A4')
        var docWidth = doc.internal.pageSize.getWidth()
        var docHeight = doc.internal.pageSize.getHeight()
        var imgWidth = docWidth - 20 // 10 for left and right margins

        doc.setFont("Helvetica")
        doc.setFontSize(22)
        doc.setTextColor(82,178,207)
        doc.setFontStyle('Bold')
        doc.text( this.meeting.name,20,30)

        var dateStr = this.$moment(this.meeting.date).format("dddd Do MMM YYYY")
        doc.setFont("Helvetica")
        doc.setTextColor('0.5')
        doc.setFontSize(12)
        doc.setFontStyle('')
        doc.text(dateStr, 20,55)

        var createCanvas = []
        this.agenda.forEach((item) => {
          var ref = this.$refs['item' + item.id][0]
          // // debugger
          // var ref = this.$refs.itemryHkf5eKhOHU3GklCVYT[0]
          // var elAgenda = this.$refs.agenda
          debugger
          createCanvas.push(this.$html2canvas(ref))
        })

        Promise.all(createCanvas).then((canvases) => {
            var y=80
            canvases.reverse().forEach((canvas) => {
              var img = canvas.toDataURL("image/jpeg,1.0")
              var aspectRatio = canvas.width / imgWidth
              var imgHeight = canvas.height / aspectRatio
              if (y + imgHeight > docHeight) {
                doc.addPage()
                y=20
              }
              doc.addImage(img, 'JPEG', 10, y,imgWidth,imgHeight)
              y += imgHeight
              debugger
            })
          doc.save('Meeting Agenda: '  +  this.meeting.name +'.pdf')
        })
        // debugger
        // return
        // const elAgenda = this.$refs.agenda
        // var meetingTitle = this.meeting.name
        // this.$html2canvas(elAgenda).then((canvas) => {
        //   var doc = new jsPDF('p', 'pt', 'A4')
        //   var docWidth = doc.internal.pageSize.getWidth()
        //   var img = canvas.toDataURL("image/jpeg,1.0")
        //   var imgWidth = docWidth-10
        //   var aspectRatio = canvas.width / imgWidth
        //   var imgHeight = canvas.height / aspectRatio
        //   doc.addImage(img, 'JPEG', 10, 80,imgWidth,imgHeight,{pagesplit:true})
        //
        //   doc.setFont("Helvetica")
        //   doc.setFontSize(22)
        //   doc.setTextColor(82,178,207)
        //   doc.setFontStyle('Bold')
        //   doc.text( this.meeting.name,20,30)
        //
        //   var dateStr = this.$moment(this.meeting.date).format("dddd Do MMM YYYY")
        //   doc.setFont("Helvetica")
        //   doc.setTextColor('0.5')
        //   doc.setFontSize(12)
        //   doc.setFontStyle('')
        //   doc.text(dateStr, 20,55)
        //
        //   doc.save('Meeting Agenda: '  +  this.meeting.name +'.pdf')
        //   // debugger
          // this.$html2canvas(elTitle).then((titleCanvas) => {
            // var titleImage = titleCanvas.toDataURL("image/jpeg,1.0")
            // doc.addImage(titleImage, 'JPEG', 10, 10,titleCanvas.height )
            //
          // })

        // })

    },
    googleCalendarEvent () {
      return {
        'summary': this.meeting.name,
        'location': '',
        'description': 'agenda',
        'start': {
          // 'dateTime': '2020-06-11T09:00:00-07:00',
          'dateTime':  this.$moment(this.meeting.date + ' ' + this.meeting.time).format(),
          'timeZone': 'America/Los_Angeles'
        },
        'end': {
          // 'dateTime': '2020-06-22T09:30:00-07:00',
          'dateTime': this.$moment(this.meeting.date + ' ' + this.meeting.time).add(this.meeting.duration,'minutes').format(),
          'timeZone': 'America/Los_Angeles'
        },
        'attendees': [
          {'email': 'matthew.walters@webautomatic.com'}
        ],
        'reminders': {
          'useDefault': false,
          'overrides': [
            {'method': 'email', 'minutes': 24 * 60},
            {'method': 'popup', 'minutes': 10}
          ]
        }
      }
    },
    sendInvitesGoogle () {
      mixpanel.track('Send Invites Google Calendar')
      this.sendingInvites = true
      var agenda = '1. Review Level 2 Plan'
      var event = this.googleCalendarEvent()
      debugger
      this.$getGapiClient()
        .then(gapi => {
          // debugger
          var request = gapi.client.calendar.events.insert({
            'calendarId': 'primary',
            'resource': event,
            'sendNotifications' : true
          })
          request.execute(event => {
            // this.meeting.googleCalendarId = event.id
            db.collection('Meetings').doc(this.id).update({googleCalendarId: event.id})

          })

        })

    },
    updateGoogleCalendar () {
      var event = this.googleCalendarEvent()
      this.$getGapiClient()
        .then(gapi => {
          alert(this.meeting.googleCalendarId)
          var request = gapi.client.calendar.events.update({
            'calendarId': 'primary',
            'eventId': this.meeting.googleCalendarId,
            'resource': event,
          })
          request.execute(event => {
            console.log('event:')
            console.log(event)
          })

        })
    },
    createCalendarICS () {
      // let now = new Date()
      // let s1 = new Date(now.getFullYear(), now.getMonth() + 1, now.getDay(), now.getHours(), now.getMinutes(), 0, 0)
      // let e1 = new Date(now.getFullYear(), now.getMonth() + 1, now.getDay(), now.getHours() + 1, now.getMinutes(), 0, 0)
      var startStr = this.meeting.date + ' ' + this.meeting.time
      var start = this.$moment(startStr)
      var end = this.$moment(start).add(this.meeting.duration,'minutes').toDate()
      var meetingPurpose = (this.meeting.purpose && this.meeting.purpose !='') ? this.meeting.purpose : ''
      this.$ics.removeAllEvents()
      this.$ics.addEvent('en-us', this.meeting.name, meetingPurpose, 'online', start, end, document.location.href,this.attendees[0],undefined,this.meeting.id)
      this.$ics.download(this.meeting.name)
      // db.collection('Meetings').doc(this.id).update({updateCalendar: '0'})
      db.collection('Meetings').doc(this.id).update({showCalendarUpdate: false})
      // this.$bind('meeting', db.collection('Meetings').doc(this.id))
    },
    itemClass (item) {
      // if(this.meeting.status === 'started' && (item.position > this.currentItem && this.editAgendaIndex != item.id)) {
      if(item.position === this.currentItem && this.editAgendaIndex != item.id){
          return 'listEntryCurrent' + ' bo' +item.position
      }
      else if((item.position > this.currentItem && this.editAgendaIndex != item.id)) {
        return 'listEntryFuture'
      } else {
        return 'listEntryPast'
      }
    },
    startMeeting () {
      db.collection('Meetings').doc(this.id).update({status: 'started', startTime: Date.now()})
      this.currentItem = 0
      window.document.getElementById('hubspot-messages-iframe-container').style.visibility='hidden'
      this.scrollToCurrentItem ()
      mixpanel.track('Start Meeting', {'date': this.meeting.date})
    },
    endMeeting () {
      this.currentItem = -1
      db.collection('Meetings').doc(this.id).update({status: 'ended', endTime: Date.now()})
      window.scroll({top: 0, left: 0, behavior: 'smooth'})
      this.showMinutes()
      window.document.getElementById('hubspot-messages-iframe-container').style.visibility=''
      mixpanel.track('End Meeting')
    },
    confirmDelete (meeting) {
      this.removeMeeting = meeting
      this.$refs.modal.show()
    },
    cancelDelete () {
      this.$refs.modal.hide()
    },
    deleteMeeting (meeting) {
      var deletions = []
      let agendaCol = db.collection('Meetings').doc(meeting.id).collection('agenda')
      agendaCol.get().then(snapshot => {
        snapshot.forEach(doc => {
          deletions.push(agendaCol.doc(doc.id).delete())
        })
        var logCollection = db.collection('Meetings').doc(meeting.id).collection('log')
        logCollection.get().then(snapshot => {
          snapshot.forEach(doc => {
            deletions.push(logCollection.doc(doc.id).delete())
          })
        })
        var attendeeCollection = db.collection('Meetings').doc(meeting.id).collection('attendees')
        attendeeCollection.get().then(snapshot => {
          snapshot.forEach(doc => {
            deletions.push(logCollection.doc(doc.id).delete())
          })
        })
        Promise.all(deletions).then((values) => {
          let m = db.collection('Meetings')
          m.doc(meeting.id).delete().then(() => {
            this.$refs.modal.hide()
            router.replace({name: 'MyMeetings'})
          })
        })
      })

    },
    showMinutes () {
      this.emailStatus = 'NOT_SENT'
      this.showMinutesModal = true
    },
    sendMinutes () {
      mixpanel.track('Send Meeting Notes')
      this.emailStatus = 'SENDING'
      var sendMinutes = firebase.functions().httpsCallable('sendMinutes')
      // var testFunction = firebase.functions().httpsCallable('testFunction')
      // var test2 = firebase.functions().httpsCallable('test2')
      sendMinutes({meetingID: this.meeting.id, meetingSendTo: this.meetingSendTo}).then(result => {
      // sendMinutes({meetingID: 'i1QRfwVNZRQwcxlH1WHR', meetingSendTo: this.meetingSendTo}).then(result => {
        this.emailStatus = 'SENT'
        setTimeout(() => this.showMinutesModal = false, 4000)
      }).catch(error => {
        this.emailStatus = 'ERROR'
        console.log('Handle Error')
        console.log(error)
      })
    },
    previousItem () {
      this.currentItem--
      var element = this.$el.getElementsByClassName('itemNo No' + (this.currentItem))[0]
      this.scrollToCurrentItem (element)
    },
    nextItem () {
      this.currentItem++
      // var element = this.$el.getElementsByClassName('itemNo No' + (this.currentItem))[0]
      this.scrollToCurrentItem ()
    },
    scrollToCurrentItem () {
      // var element = this.$el.getElementsByClassName('itemNo No' + (this.currentItem))[0]
      window.setTimeout(() => {
        var element = this.$el.getElementsByClassName('listEntryCurrent')[0]
        var itemTop = element.getBoundingClientRect().top
        var headerHeight = document.getElementsByClassName('collapseHeader')[0].offsetHeight
        var scrollY = window.scrollY
        // var scrollTo= (itemTop + scrollY) - 128
        // var scrollTo= (itemTop + scrollY) - 148
        // var scrollTo = (itemTop + scrollY) - 150
        // var scrollTo = (itemTop + scrollY) - 165
        // var scrollTo = (itemTop + scrollY)  - headerHeight - 50
        var scrollTo = (itemTop + scrollY)  - headerHeight - 16
        console.table({itemTop: itemTop, scrollY: scrollY, headerHeight: headerHeight, scrollTo: scrollTo})
        window.scrollTo({
           top: scrollTo,
           behavior: "smooth"
         })
      },500)
    },
    editMeeting () {
      router.push({name: 'EditMeeting', params: {id: this.id}})
    },
    showNewItemForm () {
      this.showNewAgendaForm = true

      this.$nextTick( () => {
        // debugger
        document.getElementById('topicNew').scrollIntoView(false)
        // this.$refs.topicNew.scrollIntoView()
      })
    },
    editItem (item) {
      this.agendaItem = this.agenda.filter(obj => {
        return obj.id === item.id
      })[0]
      this.editAgendaIndex = item.id
    },
    saveItem (item) {
      if (!item.id) {
        item.id = db.collection('Meetings').doc(this.id).collection('agenda').doc().id
        item.position = this.sortedAgenda.length
      }
      console.info('doc.id=' + item.id)
      db.collection('Meetings').doc(this.id).collection('agenda').doc(item.id).set(item)
      this.blankAgendaItem.id = ''
      this.blankAgendaItem.topic = ''
      this.blankAgendaItem.objective = ''
      this.blankAgendaItem.description = ''
      this.blankAgendaItem.position = 0
      this.blankAgendaItem.links = []
      this.showNewAgendaForm = false
    },
    saveAgendaItem (item) {
      console.log('saveAgendaItem')
      console.log(item)
      db.collection('Meetings').doc(this.id).collection('agenda').doc(item.id).set(item)
      this.editAgendaIndex = -1
    },
    doneEditItem () {
      this.agendaItem.topic = ''
      this.agendaItem.objective = ''
      this.agendaItem.owner = this.user.displayName
      this.agendaItem.duration = '15'
      this.editAgendaIndex = -1
    },
    bumpItem (item,increment) {
      var thisDocRef = db.collection('Meetings').doc(this.id).collection('agenda').doc(item.id)
      var aboveDocID = this.agenda.filter(obj => {
        return obj.position === (item.position + increment)
      })[0].id
      var aboveDocRef = db.collection('Meetings').doc(this.id).collection('agenda').doc(aboveDocID)
      var batch = db.batch()
      batch.update(thisDocRef, {position: item.position + increment})
      batch.update(aboveDocRef, {position: item.position})
      batch.commit()
        .then(refDoc => {
          // this.$bind('agenda', db.collection('Meetings').doc(this.id).collection('agenda'))
        })
    },
    removeItem (item) {
      db.collection('Meetings').doc(this.id).collection('agenda').doc(item.id).delete()
        .then(refDoc => {
          // re-number items
          var batch = db.batch()
          var i
          for (i = 0; i < this.sortedAgenda.length; i++) {
            batch.update(db.collection('Meetings').doc(this.id).collection('agenda').doc(this.sortedAgenda[i].id), {position: i})
          }
          batch.commit()
          // this.$bind('agenda', db.collection('Meetings').doc(this.id).collection('agenda'))
        })
    },
    addAttendee () {
      if (this.emailValid) {
        db.collection('Meetings').doc(this.id).collection('attendees').add(this.attendee)
        this.attendee.name = ''
        this.attendee.email = ''
        this.attendeeFormFocus = false
        this.showAttendeeForm = false
      }
    },
    // addLink (link,text,id) {
    //   // alert(link + ',' + id)
    //   db.collection('Meetings').doc(this.id).collection('agenda').doc(id).update({content:firebase.firestore.FieldValue.arrayUnion({
    //     type: 'link',
    //     url: link,
    //     title: text
    //   })})
    // },
    // deleteLink (link,agendaID) {
    //   db.collection('Meetings').doc(this.id).collection('agenda').doc(agendaID).update({
    //     content:firebase.firestore.FieldValue.arrayRemove(link)
    //   })
    // },
    setAttendeeStatus (attendee, status) {
      db.collection('Meetings').doc(this.id).collection('attendees').doc(attendee.id).update({status: status})
    },
    removeAttendee (attendee) {
      db.collection('Meetings').doc(this.id).collection('attendees').doc(attendee.id).delete()
    },
    setLogType (logType) {
      console.log('setLogType:' + logType)
      this.logItem.logType = logType
    },
    insertLog (updatedLogItem) {
      if (updatedLogItem.logType === 'action') {
        console.log('increment openActionCount')
        db.collection('Meetings').doc(this.id).update({openActionCount: this.openActions.length + 1})
        updatedLogItem.date = this.$moment(updatedLogItem.date).format('YYYY-MM-DD')
      } else if (this.logItem.logType === 'decision') {
        // db.collection('Meetings').doc(this.id).update({decisions: this.decisions})
      } else {
        delete updatedLogItem['owner']
        delete updatedLogItem['date']
      }

      updatedLogItem.timeStamp = firebase.firestore.FieldValue.serverTimestamp()

      db.collection('Meetings').doc(this.id).collection('log').add(updatedLogItem)

      updatedLogItem.text = ''
      updatedLogItem.owner = ''
      updatedLogItem.date = ''
    },
    // XinsertLog (agendaItem) {
    //   this.logItem.agendaItemId = agendaItem
    //   if (this.logItem.logType === 'action') {
    //     console.log('increment openActionCount')
    //     db.collection('Meetings').doc(this.id).update({openActionCount: this.openActions.length + 1})
    //   } else if (this.logItem.logType === 'decision') {
    //     // db.collection('Meetings').doc(this.id).update({decisions: this.decisions})
    //   } else {
    //     delete this.logItem['owner']
    //     delete this.logItem['date']
    //   }
    //
    //   this.logItem.timeStamp = firebase.firestore.FieldValue.serverTimestamp()
    //   db.collection('Meetings').doc(this.id).collection('log').add(this.logItem)
    //
    //   this.logItem.text = ''
    //   this.logItem.owner = ''
    //   this.logItem.date = ''
    // },
    deleteLogItem (logItem) {
      if (logItem.logType === 'action' && logItem.actionStatus === 'complete') {
        db.collection('Meetings').doc(this.id).update({openActionCount: this.openActions.length - 1})
      }
      db.collection('Meetings').doc(this.id).collection('log').doc(logItem.id).delete()
    },
    updateActionComplete (action) {
      mixpanel.track('Update Action Status')
      db.collection('Meetings').doc(this.id).update({openActionCount: this.openActions.length - 1})
      db.collection('Meetings').doc(this.id).collection('log').doc(action.id).update({actionStatus: 'complete'})
    },
    getLogItems (agendaItemId) {
      return this.log.filter(obj => {
        return obj.agendaItemId === agendaItemId
      })
    },
    setCurrentItem (item) {
      // this.currentItemMouseover = 0
      this.currentItemMouseover = item.id
    },
    handleScroll (e) {
      // console.log(document.documentElement.scrollTop)
      // if (document.documentElement.scrollTop > 45 ) {
      //   this.meetingScroll = true
      // } else {
      //   this.meetingScroll = false
      // }
    }
  },
  created: function () {
    // window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function () {
    mixpanel.track('View Meeting')
    if (this.$route.query.id !== undefined) {
      this.id = this.$route.query.id
      this.$bind('meeting', db.collection('Meetings').doc(this.id))
      this.$bind('agenda', db.collection('Meetings').doc(this.id).collection('agenda'))
      this.$bind('log', db.collection('Meetings').doc(this.id).collection('log').orderBy('timeStamp'))
      this.$bind('attendees', db.collection('Meetings').doc(this.id).collection('attendees')).then((doc) => {
        if (this.attendees.length === 0) {
          db.collection('Meetings').doc(this.id).collection('attendees').add({name: this.user.displayName, email: this.user.email, status: 'Happy'})
        }
        // this.countDown = this.$moment.duration(parseInt(this.meeting.duration), 'minutes')
        // if (this.meeting.status === 'started') {
        // this.interval = setInterval(() => this.updateCountDown(), 15000)
        // }
      })
    }
  },
  destroyed: function () {
    clearInterval(this.interval)
  },
  components: {
    Timer: Timer,
    EditAgendaItem: EditAgendaItem,
    PostLogItem: PostLogItem,
    ListLogItems: ListLogItems,
    MeetingTime: MeetingTime
  },
  filters: {
  trim: function (value) {
    if (!value) return ''
    var arr = value.toString().split('\n').shift()
    // return value.charAt(0).toUpperCase() + value.slice(1)
    debugger
    return arr.join('zzz')
  }
}
}
</script>
<style scoped>



  /* Meeting Header */
  .header{padding:20px 2.5rem;  margin-bottom: 3rem; }
  /* .collapseHeader {padding:5px 2.5rem 25px; height: 6rem; background-color: white; position: fixed; z-index: 1000; top: 0; width: 100%; box-shadow: 0 0px 17px 0 rgba(50,70,90,.2)} */
  /* .collapseHeader {padding:5px 2.5rem 25px; height: 6rem; background-color: white; position: fixed; z-index: 1000; top: 0; width: 100%; box-shadow: 0 0px 4px 0 rgba(50,70,90,.2); z-index:10} */
  .collapseHeader {Xborder-bottom: 1px solid #00000020; padding:5px 2.5rem 0px; height: 7rem; display: flex; align-items: center; background-color: white; position: fixed; top: 0;  z-index: 1000; width: 100%; Xbox-shadow: 0 0px 4px 0 rgba(50,70,90,.2); z-index:10}
  .meetingDetails.container-fluid {margin:20px 50px;padding:0px}
  .meetingTitle {font-size: 2.3rem; font-weight:bold; color:var(--primaryColor1); line-height: 1.6rem; margin-top:1rem; cursor:pointer }
  .meetingPurpose {font-size:0.5rem; Xcolor: #808080;line-height: 1.1rem; color:var(--primaryColor1)}
  .meetingTime {color: #808080; font-size: 1.2rem }
  .timeRemaining {color: #808080}
  /* .timer {color: var(--primaryColor1); float: right; font-weight: 500; font-size: 2.5rem; font-family: 'Courier Prime', monospace} */
  .timer {Xcolor:#808080; color:var(--primaryColor1); float: right; font-weight: 600; font-size: 3rem; font-family: 'Share Tech Mono', monospace; Xmargin-left: auto}
  .timerMessage {font-size:.9rem; color:#808080;}
  #meetingSpacer {background-color: green; height:3px; width:100%; background-image: linear-gradient(lightgray,white);margin-top: 15px}


  .meetingContent.container-fluid {margin:35px 50px; padding:0px;background-color: papayawhip}
  @media only screen and (min-width: 768px) {
    .card{width:90%;margin-bottom:15px}
    .card-body{padding:5px;margin:5px}
    .card-Text{margin:0px; padding:0px}
    .card h4{}
  }
  .topM{margin-top:20px}
  .active{border: #57767B solid 1px}
  .flip-list-move {transition: transform .6s;}

  .attendee{padding: 0px 0px; xmax-width:250px; margin: 10px 0;}
  .attendeeForm {padding: 10px 0px; max-width:250px; margin: 10px 0}
  .attendeeName{font-size:1rem; font-weight: 400;}
  .attendee .form-group{margin-top:0.2rem;margin-bottom: 0}
  .attendee .row{Xborder-top: 1px solid #00000020; padding:0.1em 0}
  .attendeeForm .row{margin:0.1em 0}
  .attendee.container{margin:0; background-color: #f7f7f6; border-radius: 15px; margin-bottom: 10px;}
  .attendeeForm.container{margin:0; padding:0}

  .moodButton{font-size:.85rem; Xcolor: #F7B267; color:var(--primaryColor1)}
  .moodButton.notHere { font-size: 1rem}
  .moodIcon{font-size: 1.3rem; Xcolor: #F7B267; color:var(--primaryColor1); z-index:99999}

  .btn .btn-lnk {background-color:green; color:pink}
  #dropButton{}


  .agendaItemDetail.container-fluid{margin:0; padding:0}
  .XitemControls {xbackground-color: pink}
  .itemControls .btn-link{color: #57767B}
   .card.itemCutOut {margin-top:1.4rem;border: dashed 1px rgba(0, 0, 0, 0.25); height:5rem;justify-content:center;font-weight:400;color:gray;font-weight: 500}
  .meetingPurpose {font-size: 1.1rem; font-style:italic}
/*
  .logAction .btn-outline-primary.dropdown-toggle {Xcolor:#57767B}
  .logEntries.container-fluid{margin:0px;padding: 0px}
  .logEntry .container-fluid{margin:0px;padding: 0px}
  .logEntry{background-color: var(--lightGray); border-radius: 5px; padding: 3px 6px;margin:8px 0px}
*/
.logItemsContainer {margin-top: auto; background-color: var(--lightGray); padding-left: 0.5rem; padding-top: 0.2rem; Xpadding-bottom: 0.5rem; padding-bottom: 0.2rem; padding-right: 0.5rem; border-radius: 10px; Xposition: absolute; bottom: 1rem; Xwidth: 95%; Xheight: 6rem}
.meetingOutcomesLabel {font-size: 0.9rem;font-weight: 600;font-style: italic; Xpadding-left: 0.3rem; Xpadding-top: 0.3rem}
.logEntry{background-color: yellow !important}
.logEntries{}
.logEntries.started {max-height: 15rem; overflow-y: scroll}
/* Show div scrollbars */
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

  .notesLabel{font-style: italic;margin-bottom: -8px;margin-top:8px}

  .meetingLink{max-width: 250px}
  .attendeesFixed {Xbackground-color: pink; position: fixed; right: 2rem; top: 7.7rem; width:19rem}


  .attendees {Xbackground-color: yellow}
  .attendee .row{Xbackground-color: azure}
  .actions{border:1px solid #00000020; padding:5px}
  th.actions{background-color:#00000020;font-weight: normal; border:1px solid white; padding: 5px}

  #addAttendeeIcon{color:#afadad;cursor:pointer}
  #addAgendaItemIcon{color:#afadad;cursor:pointer}
  #closeMeetingIcon {color: #afadad; cursor:pointer; font-size: 1.65rem}

  .listEntryCurrent {margin-bottom: 2rem;border-bottom-width: 1px !important; border-left-width: 4px; min-height: 25rem; display: flex; flex-direction: column}
  .listEntryFuture {Xmax-height: 10rem}
  .listEntryPast {margin-bottom: 2rem;border-bottom-width: 1px !important}


  /* .listEntryStarted{max-height: 4.5rem;} */
  .list-group-item {border-top-width: 1px !important; border-bottom-width: 0px; Xborder-radius: 8px}
  .list-group-item:last-child {border-bottom-width: 1px !important}
  .itemLeftCol {display:flex;flex-direction: column;margin-left: -10px}
  .itemRightCol {display:flex;flex-direction: column;align-items: flex-end;}
  .row.itemRow{padding:0 0 0 0}
  .row.itemRow.top{margin-top:0.1rem}

  .itemNo {
      border-radius: 50%;
      font-size: 1.1rem;
      background-color: #f8f8f8;
      width: 2.2rem;
      height: 2.2rem;
      line-height: 2.2rem;
      text-align: center;
      font-weight: bold;
      /* margin: auto; */
      color: white;
      margin-right: auto;
    margin-left: auto;
    margin-top: 0.3rem;
  }

  .currentitemNo {
  border-radius: 50%;
  font-size: 2.1rem;
  background-color: gray;
  font-weight: bold;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  padding: 0;
  margin: auto;
  color: white;
}
  /* .itemObjective{font-size:.8rem} */
  .itemOwner{font-size:1rem;color: #808080; font-size: 1rem}
  .itemHeader{height:3rem; display:flex}
  .itemBody{margin-top: 0.4rem}
  .bumpItem{color:#afadad;font-size:2rem; cursor:pointer}
  .itemTitle{font-size:1.4rem; font-weight:bold; line-height:1.2rem; margin-top: 0.06rem }
  .currentItemTitle {font-size:1.8rem; font-weight:bold; line-height:1.9rem; margin-bottom: 0.2rem; margin-top: 0.2rem}
  .itemObjective{font-size:0.95rem; font-style: italic; color: #808080;margin-bottom: 0.5rem;}
  .editItemIcon{line-height: 1.2rem; cursor:pointer; color:#afadad; margin-right:0.8rem}
  .editItemIcon:hover{color:var(--primaryColor1)}
  .itemTime{margin-left: 0.5rem;font-weight: 600; font-size:1.2rem;line-height: 1.2rem}
  .list-group {width:90%}
  .itemNotes {font-size: 0.9rem;Xcolor: #262626; color: #808080; white-space: pre-line; margin-top:-0.3rem; margin-left: 1.8rem;font-weight:500; padding-bottom:1rem}
  .itemNote {font-size: 0.9rem;Xcolor: #262626; color: #808080; white-space: pre-line;}
.itemNotes ::marker {
    Xcontent:	'> ';
    Xcontent: '☐';
    content: '■ ';
    Xcontent: '🚦';
    /* font-weight:600; */
    Xfont-size: 1.25rem;
    font-size: 0.8rem;
    margin-right: 2rem;
  }
  .descriptionBullet{adding-bottom: 1.3rem}
  .itemLink {font-size: 0.75rem; }

  .fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
